
  import { Component, Vue } from 'vue-property-decorator';
  import { FETCH_TAGS } from '@/store/tags';
  import InsightEdit from '@/components/InsightEdit.vue';
  import { CREATE_INSIGHT, RESET_STATE } from '@/store/insights';

  @Component({
    components: { InsightEdit }
  })
  export default class InsightsCreate extends Vue {
    beforeMount() {
      this.$store.dispatch(FETCH_TAGS);
      this.$store.commit(RESET_STATE);
    }

    public save() {
      if (!(this.$refs.insightEdit as InsightEdit).checkValidation()) {
        return;
      }

      this.$store.dispatch(CREATE_INSIGHT)
        .then(() => this.$router.push({ name: 'app.insights.list' }));
    }
  }
